<template>
  <slot />
  <UPagination
    v-if="itemsMeta.total > itemsMeta.per_page"
    v-model="page"
    :total="itemsMeta.total"
    :page-count="itemsMeta.per_page"
    class="mt-6"
    @update:model-value="onPageChange"
  />
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    itemsMeta?: {
      per_page: number
      total: number
    }
  }>(),
  {
    itemsMeta: () => ({
      per_page: 20,
      total: 0,
    }),
  },
)

const route = useRoute()

const page = defineModel<number>({ default: 1 })

watch(
  () => route.query.page,
  (newPage) => {
    page.value = Number(newPage) || 1
    scrollToTop()
  },
)

async function onPageChange(newPage: number) {
  await navigateTo({
    query: {
      ...route.query,
      page: newPage.toString(),
    },
  })
  scrollToTop()
}
</script>

<style lang=""></style>
